import React from 'react';

type CommonQuestionsProps = {
  commonlyAskedQuestionList: Array<{ fields: { textValue: string } }>;
  commonQuestionTitle: string;
  sendChatMessage: (question: string) => void;
  hideCommonQuestions?: boolean;
};

const CommonQuestions: React.FC<CommonQuestionsProps> = ({
  commonlyAskedQuestionList,
  commonQuestionTitle,
  sendChatMessage,
  hideCommonQuestions = false,
}) => {
  if (
    !commonlyAskedQuestionList ||
    commonlyAskedQuestionList.length === 0 ||
    hideCommonQuestions
  ) {
    return null;
  }

  return (
    <div className="text-lg font-semibold mx-6 mb-8 custom1200:col-start-2 custom1200:col-span-4">
      <div className="my-6">{commonQuestionTitle}</div>
      <div className="flex flex-col custom1200:flex-row gap-6 flex-wrap">
        {commonlyAskedQuestionList.map((question, index) => (
          <div
            key={index}
            className="bg-success-50 p-4 rounded-lg shadow-md relative h-[100px] custom1200:w-[45%] custom1200:basis-[45%] w-full"
          >
            <div className="absolute top-[20px] left-[-12.5px] h-[36px] w-[12.5px] bg-success-other rounded-tl-lg rounded-bl-lg"></div>
            <button
              className="text-base"
              onClick={() => {
                sendChatMessage(question.fields.textValue);
              }}
            >
              {question.fields.textValue}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommonQuestions;
